import { useIntl } from 'react-intl';

import type { ButtonProps } from '@/components/LegacyButton';
import { LegacyButton } from '@/components/LegacyButton';
import { Visibility } from '@/components/Visibility';
import { getVariantCTA } from '@/lib/product';
import type { CtaType } from '@/lib/types';

export interface CTAProps
  extends Pick<ButtonProps, 'isProcessing' | 'disabled' | 'onClick'> {
  cta: CtaType | undefined;
  loading: boolean;
}

export const CTA = ({ cta, loading, ...props }: CTAProps) => {
  const { formatMessage } = useIntl();

  if (!cta) {
    return null;
  }

  return (
    <Visibility data-test-id='CTAVisibility' handleDisplay={false}>
      <LegacyButton
        colorVariant={loading ? 'gray' : 'primary'}
        data-test-id='CTALegacyButton'
        disabled={loading}
        isFluid
        label={loading ? '' : getVariantCTA(formatMessage, cta)}
        {...props}
      />
    </Visibility>
  );
};
